import React from "react";
import { useTranslation } from "react-i18next";
import { UserCog } from "lucide-react";
import EmailChangeSection from "../components/settings/EmailChangeSection";
import ProfileIdentitySection from "../components/settings/ProfileIdentitySection";
import LanguageSection from "../components/settings/LanguageSection";
import WorkspaceContextSection from "../components/settings/WorkspaceContextSection";
import DangerZoneSection from "../components/settings/DangerZoneSection";

export default function SettingsProfile() {
  const { t } = useTranslation("common");
  return (
    <div className="animate-fade-up" data-testid="settings-profile-page">
      <div className="mb-8">
        <p className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 mb-2 inline-flex items-center gap-1.5">
          <UserCog size={12} strokeWidth={1.75} />
          {t("settings.profile.nav_label")}
        </p>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-zinc-950">
          {t("settings.profile.title")}
        </h1>
        <p className="text-sm text-zinc-500 mt-1.5 max-w-xl">{t("settings.profile.subtitle")}</p>
      </div>
      <ProfileIdentitySection />
      <EmailChangeSection />
      <LanguageSection />
      <WorkspaceContextSection />
      <DangerZoneSection />
    </div>
  );
}
